import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ClubSanctionListApi = (data) => API.get(`${URL.CLUB_SANCTION_LIST}`, data)
